<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="800px"
      v-bind:body-style="{ height: '400px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row >
          <a-col :span = "12">
            <a-form-model-item label="客户名称:" prop="accountName">
            <a-input v-model="searchList.accountName" :allowClear="true":disabled="true"/>
          </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="账户编号:" prop="accountNo">
            <a-input v-model="searchList.accountNo" :allowClear="true" :disabled="true"/>
          </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="type == '1'">
          <a-col :span = "12">
            <a-form-model-item label="充值金额:" prop="amount">
            <a-input type="number" suffix="元" v-model="searchList.amount"
                    placeholder="请输入充值金额" />
          </a-form-model-item>
          </a-col>
          <a-col :span = "12"></a-col>
        </a-row>
        <a-row v-if="type == '2'">
          <a-col :span = "12">
            <a-form-model-item label="退费金额:" prop="amount">
            <a-input type="number" suffix="元" v-model="searchList.amount"
                    placeholder="请输入退费金额" />
          </a-form-model-item>
          </a-col>
          <a-col :span = "12"></a-col>
        </a-row>
        <a-row v-if="type == '2'">
          <a-col :span = "12">
            <span style="margin-left: 120px;">账户余额：{{ searchList.accountAmount }}元</span>
            <span style="color:rgba(22, 130, 139, 1);margin-left: 20px;" @click="handleInsert(searchList.accountAmount)">全部退款</span>
          </a-col>
          <a-col :span = "12"></a-col>
        </a-row>
        <a-row v-if="type == '1'">
          <a-col :span = "24">
            <div style="margin-bottom: 25px;">
              <a-button class="cancel-color" style="margin-right: 10px;margin-left: 120px;" ghost @click="handleInsert(30000.00)">30000.00</a-button>
              <a-button class="cancel-color" style="margin-right: 10px;" ghost @click="handleInsert(10000.00)">10000.00</a-button>
              <a-button class="cancel-color" style="margin-right: 10px;" ghost @click="handleInsert(5000.00)">5000.00</a-button>
            </div>
          </a-col>
        </a-row>
        <a-row v-if="type == '1'">
          <a-col :span = "24">
            <a-form-model-item
              label="充值凭证"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
            >
              <upload  :downid="detailId" uploadNum="1" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="cancel-color" ghost @click="handleCancel">取消</a-button>
      <a-button  class="btn-color" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import upload from "@/components/upload/upload.vue";
import{
  accountDetail,topupAccount
} from "@/api/api.js";
export default {
  components: { upload },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    
    accountNo: {type: String},//账户编号
    type: {type: String},//类型（充值/退款）
    detailId:{type: String},//附件busId
    data: {
      type: Array,
      default: () => [],
    },//返回信息
  },
  data() {
    //自定义校验规则
    var checkPrice = (rule, value, callback) => {
      if (value) {
        if (Number(value) <= 0) {
            return callback(new Error('请输入大于0的数'));
        } else if (Number(value) > 99999999) {
          return callback(new Error('充值金额不能超过8位数'));
        } else if(!/^\d+\.*\d{0,2}$/ig.test(value)){
          return callback(new Error('输入不能超过两位小数'));
        }
      } else {
        return callback();
      }
      return callback();
    };
    return {
      id: "",
      uploadAgain: false,
      fileNum: 0,
      imgUrl :'',
      imgId :[],
      visible: true,
      discounts:[],
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      okLoad: false,

      //绑定值
      searchList: {
        id:this.detailId,
        accountNo: this.accountNo,
        accountName:"",
        accountAmount:"",
        amount:0,
        imgUrl:""
      },

      //校验规则
      rules: {
        amount: [
          {
            required: true,
            message: "充值金额不能为空！",
            trigger: "blur",
          },
          {
            validator: checkPrice,
            trigger: "change",
          }
        ],
      },
    }
  },
  mounted() {
    //获取id
      console.log("this.detailId ",this.detailId );
      //获取账户详情
      accountDetail({accountNo: this.accountNo}).then(
        (res) => {
          if (res.code == '0000') {
            res.content.amount = 0;
            this.searchList = res.content;
          }
        },
        (err) => {
          this.$message.error('查询账户信息失败')
        }
      )
      this.searchList.id = this.detailId; 
},
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },
    //将按钮值放入文本框中 
    handleInsert(val){
      this.searchList.amount = val;
    },
    //保存
    handleOk() {
      let paramObj={
        id:this.detailId,
        accountNo:this.searchList.accountNo,
        amount:this.searchList.amount,
        consumpStatus:this.type == '1' ? '1' : '5',
      }
      //弹窗确定
      if (Number(this.searchList.amount) <= 0) {
        return this.$message.warning('请输入大于0的数');
        }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.okLoad = true
          topupAccount(paramObj).then(
              (res) => {
                if (res.code == '0000') {
                  this.okLoad = false;
                  if(this.type == '1'){
                    this.$message.success('充值成功');
                  }else{
                    this.$message.success('退款成功');
                  }
                  this.$emit('handleOk');
                }
              },
              (err) => {
                this.okLoad = false
              }
            )
        };
      })
    },

    //监听附件组件
    listen(val) {
      this.uploadAgain = false;
      if(val.length == 0){
        this.imgUrl = false;
        this.searchList.imgUrl ="";
      } else {
        this.imgUrl = true;
        this.imgId = val[0].id;
        this.searchList.imgUrl = val[0].id;
        this.uploadAgain = true;//监听是否已上传文件
      }
      this.fileNum = val.length;
    },

  },
}
</script>

<style scoped>
.btn-color {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}
.cancel-color{
  border-color: rgba(22, 130, 139, 1);
  color: rgba(22, 130, 139, 1);
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
